module.exports = __webpack_public_path__ + "img/scene1-3D.59b8dbb1.gif";